module.exports = __webpack_public_path__ + "img/user-menu-male.1eb54461.png";